import type { ComponentProps, ReactNode } from 'react';

import { Slot as RadixSlot, Slottable } from '@radix-ui/react-slot';

export { Slottable };

/**
 * Renders as its child, merging props and behaviour onto it.
 * Pass an extra props type as a type argument to allow element-specific props.
 *
 * Basic usage:
 * ```tsx
 * <Slot onClick={onClick}>
 *   <button type="button">Delete</button>
 * </Slot>
 * ```
 *
 * Allowing element-specific props (e.g. `disabled`):
 * ```tsx
 * <Slot<{ disabled?: boolean }> disabled onClick={onClick}>
 *   <button type="button">Delete</button>
 * </Slot>
 * ```
 */
export const Slot = <P extends object = object>(props: ComponentProps<typeof RadixSlot> & P): ReactNode => (
    <RadixSlot {...props} />
);
